import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Nav from "../../Components/Nav/Nav";
import Login from "../../Pages/Login";
import AdminMenu from "../../Components/Admin/AdminMenu";
import AdminFormHeader from "./AdminFormHeader";
import { getKnwoledge } from "../../actions/knowledge.actions";
import { getPosts } from "../../actions/post.actions";
import moment from "moment";
import { getComments } from "../../actions/comment.actions";
import { getLikes } from "../../actions/likes.actions";
import LikeChart from "./LikeChart";
import TutoCategorieChart from "./TutoCategorieChart";
import OnlineUsers from "./OnlineUsers";
import ImageProfil from "../Profil/ImageProfil";
import {
  Users,
  BookOpen,
  FileText,
  ThumbsUp,
  MessageSquare,
  TrendingUp,
  LineChart as LineIcon,
  PieChart as PieIcon,
  Wifi,
  UserX,
} from "lucide-react";

const StatCard = ({ title, value, icon, color, subtext }) => (
  <div className="dash-kpi-card">
    <div
      className="dash-kpi-icon"
      style={{ backgroundColor: `${color}20`, color }}
    >
      {icon}
    </div>
    <div className="dash-kpi-body">
      <span className="dash-kpi-title">{title}</span>
      <span className="dash-kpi-value">{value}</span>
      {subtext && <span className="dash-kpi-sub">{subtext}</span>}
    </div>
  </div>
);

const AdminDashBoard = () => {
  const userData = useSelector((state) => state.userReducer);
  const usersData = useSelector((state) => state.usersReducer);
  const tutosData = useSelector((state) => state.knowledgeReducer);
  const postsData = useSelector((state) => state.postReducer);
  const commentairesData = useSelector((state) => state.commentReducer);
  const likesData = useSelector((state) => state.likesReducer);
  const dispatch = useDispatch();

  const totalUsers = Object.values(usersData).length;
  const totalTuto = Object.values(tutosData).length;
  const totalPosts = Object.values(postsData).length;
  const totalCommenaites = Object.values(commentairesData).length;
  const totalLikes = Object.values(likesData).length;

  const totalPostsMonthly = Object.values(postsData).filter((post) => {
    const currentMonthAndYear = moment().format("MM-YYYY");

    const postMonthAndYear = moment(post?.createdAt).format("MM-YYYY");
    return postMonthAndYear === currentMonthAndYear;
  });

  const usersInactiveFor5Days = Object.values(usersData).filter((user) => {
    return (
      (moment(user.lastLogin).isBefore(moment().subtract(5, "days")) ||
        user.lastLogin === null) &&
      user.firstname !== "Ancien"
    );
  });

  useEffect(() => {
    dispatch(getKnwoledge());
    dispatch(getPosts());
    dispatch(getComments());
    dispatch(getLikes());
  }, [dispatch]);

  const kpis = [
    {
      title: "Utilisateurs",
      value: totalUsers,
      icon: <Users size={24} />,
      color: "#f59e0b",
      subtext: "Comptes enregistrés",
    },
    {
      title: "Tutoriels",
      value: totalTuto,
      icon: <BookOpen size={24} />,
      color: "#10b981",
      subtext: "Tutoriels publiés",
    },
    {
      title: "Posts ce mois",
      value: totalPostsMonthly.length,
      icon: <FileText size={24} />,
      color: "#4f46e5",
      subtext: `${totalPosts} au total`,
    },
    {
      title: "Likes",
      value: totalLikes,
      icon: <ThumbsUp size={24} />,
      color: "#8b5cf6",
      subtext: "Likes cumulés",
    },
  ];

  const postStats = [
    { label: "Post total", value: totalPosts, icon: <TrendingUp size={20} /> },
    {
      label: "Commentaire total",
      value: totalCommenaites,
      icon: <MessageSquare size={20} />,
    },
    { label: "Like total", value: totalLikes, icon: <ThumbsUp size={20} /> },
  ];

  return (
    <>
      {userData.isAdmin ? (
        <>
          <Nav />
          <div className="mainContainer">
            <AdminMenu />
            <div className="centerBlockDashboard">
              <AdminFormHeader
                title="Tableau de bord"
                subtitle="Vue d'ensemble de l'activité de la plateforme."
              />

              {/* KPI cards */}
              <div className="dash-kpi-grid">
                {kpis.map((k) => (
                  <StatCard key={k.title} {...k} />
                ))}
              </div>

              {/* Statistiques Post */}
              <div className="dash-card">
                <div className="dash-card-header">
                  <h3 className="dash-card-title">Statistiques Post</h3>
                  <span className="dash-card-sub">
                    {totalPostsMonthly.length} post(s) ce mois
                  </span>
                </div>
                <div className="dash-post-stats">
                  {postStats.map((s) => (
                    <div className="dash-post-stat" key={s.label}>
                      <div className="dash-post-stat-icon">{s.icon}</div>
                      <div className="dash-post-stat-body">
                        <span className="dash-post-stat-label">{s.label}</span>
                        <strong className="dash-post-stat-value">
                          {s.value}
                        </strong>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Charts */}
              <div className="dash-charts-grid">
                <div className="dash-card">
                  <div className="dash-card-header">
                    <h3 className="dash-card-title">Statistiques des Likes</h3>
                    <LineIcon size={18} color="#9ca3af" />
                  </div>
                  <LikeChart postsData={postsData} likesData={likesData} />
                </div>
                <div className="dash-card">
                  <div className="dash-card-header">
                    <h3 className="dash-card-title">Répartition des tutoriels</h3>
                    <PieIcon size={18} color="#9ca3af" />
                  </div>
                  <TutoCategorieChart tutosData={tutosData} />
                </div>
              </div>

              {/* Users */}
              <div className="dash-users-grid">
                <div className="dash-card">
                  <div className="dash-card-header">
                    <h3 className="dash-card-title">Utilisateurs en ligne</h3>
                    <Wifi size={18} color="#10b981" />
                  </div>
                  <OnlineUsers userData={userData} />
                </div>
                <div className="dash-card">
                  <div className="dash-card-header">
                    <h3 className="dash-card-title">
                      Utilisateurs inactifs depuis 5 jours
                    </h3>
                    <UserX size={18} color="#9ca3af" />
                  </div>
                  {usersInactiveFor5Days.length === 0 ? (
                    <p className="dash-empty">
                      Tous les utilisateurs sont actifs.
                    </p>
                  ) : (
                    <ul className="usersOnlineDashboard">
                      {usersInactiveFor5Days.map((user) => (
                        <li key={user.id} className="userOnline_list">
                          <ImageProfil id={user.id} /> {user.firstname}{" "}
                          {user.name}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <Login />
      )}
    </>
  );
};

export default AdminDashBoard;
